var map = {
	".": "BJ4d",
	"./": "BJ4d",
	"./01_limit": "+dFG",
	"./01_limit.json": "+dFG",
	"./02_connect": "hDC3",
	"./02_connect.json": "hDC3",
	"./03_data_compress": "YUWz",
	"./03_data_compress.json": "YUWz",
	"./04_heart_beat": "Ze9p",
	"./04_heart_beat.json": "Ze9p",
	"./05_cancel_subscribe": "hlb8",
	"./05_cancel_subscribe.json": "hlb8",
	"./06_subscribe": "g2tG",
	"./06_subscribe.json": "g2tG",
	"./index": "BJ4d",
	"./index.js": "BJ4d"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JLT+";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/introduce ^.*$
// module id = JLT+
// module chunks = 3